import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  platform: [],
  segment_list: null,
  selected_segments: null,
};
export const metaSearchSlice = createSlice({
  name: "metaSearchSlice",
  initialState: initialState,
  reducers: {
    updatePlatform: (state, action) => {
      state.platform = action.payload;
    },
    updateSegmentList: (state, action) => {
      state.segment_list = action.payload;
    },
    updateSelectedSegments: (state,action) => {
      state.selected_segments = action.payload;
    },
    resetMetaSearch: () => initialState
  },
});

export const {
  updatePlatform,
  updateSegmentList,
  updateSelectedSegments,
  resetMetaSearch
} = metaSearchSlice.actions;
export default metaSearchSlice.reducer;
